import { getBusinessType,getBusiness } from "@/constant"
import { param2Obj, hash2Obj } from '@/utils/utils.js'

const requestParamHandler = (url, params) => {
    let requestUrl =  ''
    const { redirect_url, share_id, share_source, hannels} = param2Obj(window.location.href)
    const { gi_guest } = params
    const shareParam = `?share_id=${share_id}&share_source=${share_source}`
    const giguestParam = `?gi_guest=${gi_guest}${hannels ? '&hannels=' + hannels : ''}`
    const thirdApp = `?name=${getBusiness()}&redirect_url=${redirect_url}`
    // 非三方获取code应用
    if (getBusinessType().selfLogin) {
        requestUrl = `${url}${share_id ? shareParam : giguestParam}`
    } else {
        requestUrl = `${url}${thirdApp ? thirdApp : giguestParam}`
    }
    return requestUrl
}
export {
    requestParamHandler
}